/** AMM activity does not carry the fully joined portfolio row. Preserve the
 * normalized index until the event-scoped authoritative reconcile resolves. */
export function retainActivityIndex<T>(previous: T, ..._ignored: readonly unknown[]): T {
  return previous;
}
